import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'Logo' })((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        userSelect: 'none',
        textDecoration: 'none'
    },
    image: {
        objectFit: 'contain'
    },
    text: {
        color: '#232323',
        fontSize: 20,
        fontWeight: 600,
        lineHeight: '100%',
        letterSpacing: '-0.4px',
        textTransform: 'lowercase',
        display: 'none',
        whiteSpace: 'nowrap',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            display: 'inline-block'
        }
    }
}));
